import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Article, Card } from '../common/Layout'
import { historyRoute } from '../../routes/routes'

class Contact extends Component {
  render() {
    return (
      <Article>
        <Card>
          <h1 className="title">Contact Us!</h1>
          <h3 className="center-xs">Questions about an order?</h3>
          <div className="content">
            <p className="row">
              You can submit a ticket to Foodsby Support or call the restaurant
              directly. Please click below to find your order.
            </p>
          </div>
          <div className="row center-xs">
            <Link className="button primary" to={historyRoute.path}>
              View Your Orders
            </Link>
          </div>
          <hr />
          <br />
          <div className="row center-xs">
            <h3>For other questions, comments, or feedback</h3>
            <p>
              Send us an email at{' '}
              <a href="mailto:support@foodsby.com" target="_top">
                support@foodsby.com
              </a>
            </p>
            <div className="col-xs-12">
              3001 Broadway St NE STE 170
              <br />
              Minneapolis, MN 55413
            </div>
          </div>
        </Card>
      </Article>
    )
  }
}
export default Contact
